// extracted by mini-css-extract-plugin
export default {"body":"footer_body__11po4"};